export const STATUS_META = {
  submitted: { label: "Revisión técnica", severity: "info" },
  correction_requested: { label: "Corrección solicitada", severity: "danger" },
  accepted: { label: "Aceptada", severity: "info" },
  preparing: { label: "En preparación", severity: "warning" },
  ready_for_commercial_review: { label: "Por validar", severity: "help" },
  commercial_rejected: { label: "Preparación rechazada", severity: "danger" },
  approved_for_transport: {
    label: "Aprobada para traslado",
    severity: "success",
  },
  active: { label: "Demo activa", severity: "success" },
  pending_pickup: { label: "Pendiente de retiro", severity: "warning" },
  pending_commercial_close: { label: "Pendiente de cierre", severity: "info" },
  closed: { label: "Cerrada", severity: "success" },
  cancelled: { label: "Cancelada", severity: "danger" },
};

export const STATUS_FILTERS = [
  { label: "Todas", value: "" },
  { label: "Nuevas", value: "submitted,correction_requested" },
  { label: "En preparación", value: "accepted,preparing,commercial_rejected" },
  { label: "Por validar", value: "ready_for_commercial_review" },
  { label: "Demo activa", value: "approved_for_transport,active" },
  { label: "Por retirar", value: "pending_pickup" },
  { label: "Por cerrar", value: "pending_commercial_close" },
  { label: "Historial", value: "closed,cancelled" },
];

export const PRIORITY_OPTIONS = [
  { label: "Normal", value: "normal" },
  { label: "Alta", value: "high" },
  { label: "Urgente", value: "urgent" },
];

export const OBJECTIVE_OPTIONS = [
  { label: "Primera degustación", value: "first_tasting" },
  { label: "Propuesta de nuevos productos", value: "new_products" },
  { label: "Recuperar la relación", value: "recover_relationship" },
  { label: "Prueba de máquina", value: "machine_trial" },
  { label: "Evento o activación", value: "event" },
  { label: "Otro", value: "other" },
];

export const MACHINE_TYPE_OPTIONS = [
  { label: "Café", value: "coffee" },
  { label: "Snack", value: "snack" },
  { label: "Bebidas", value: "drink" },
  { label: "Combinada", value: "combo" },
  { label: "Dispensador", value: "dispenser" },
  { label: "Otro", value: "other" },
];

export const WATER_SUPPLY_OPTIONS = [
  { label: "No aplica", value: "not_applicable" },
  { label: "Conexión hídrica", value: "water_line" },
  { label: "Botellón", value: "bottle" },
  { label: "Por confirmar", value: "unknown" },
];

export const PAYMENT_OPTIONS = [
  { label: "Consumo gratuito", value: "free" },
  { label: "Efectivo", value: "cash" },
  { label: "Monedas", value: "coins" },
  { label: "Billetes", value: "bills" },
  { label: "Tarjeta", value: "card" },
  { label: "Yappy", value: "yappy" },
  { label: "Código QR", value: "qr" },
  { label: "Llave", value: "key" },
  { label: "Código de cortesía", value: "courtesy_code" },
  { label: "Otro", value: "other" },
];

export const FORMULATION_OPTIONS = [
  { label: "Formulación estándar", value: "standard" },
  { label: "Formulación especial", value: "special" },
  { label: "No aplica", value: "not_applicable" },
];

export const LIMIT_OPTIONS = [
  { label: "Sin límite", value: "unlimited" },
  { label: "Cantidad de días", value: "days" },
  { label: "Número de tazas/productos", value: "cups" },
];

export const ACCESSORY_OPTIONS = [
  { label: "Nevera para leche", value: "milk_fridge" },
  { label: "Manguera de leche", value: "milk_hose" },
  { label: "Botellón", value: "water_bottle" },
  { label: "Bomba", value: "pump" },
  { label: "Filtro", value: "filter" },
  { label: "Carretilla", value: "hand_truck" },
  { label: "Extensión eléctrica", value: "extension_cord" },
  { label: "Protector de voltaje", value: "voltage_protector" },
  { label: "Mesa o base", value: "base" },
  { label: "Kit de limpieza", value: "cleaning_kit" },
  { label: "Vasos", value: "cups" },
  { label: "Paletinas", value: "stirrers" },
  { label: "Tapas", value: "lids" },
  { label: "Servilletas", value: "napkins" },
  { label: "Productos iniciales", value: "initial_stock" },
  { label: "Material promocional", value: "promotional_material" },
];

export const FEEDBACK_RESULT_OPTIONS = [
  { label: "Oportunidad de venta", value: "sale_opportunity" },
  { label: "Cotización solicitada", value: "quote_requested" },
  { label: "Prueba extendida", value: "extended_trial" },
  { label: "Seguimiento pendiente", value: "follow_up" },
  { label: "Sin interés", value: "no_interest" },
  { label: "Otro", value: "other" },
];

export const ACTION_META = {
  edit: { label: "Editar solicitud", icon: "pi pi-pencil" },
  resubmit: { label: "Reenviar a Técnicos", icon: "pi pi-send" },
  request_correction: {
    label: "Solicitar corrección",
    icon: "pi pi-undo",
    severity: "danger",
    requiresNote: true,
  },
  accept: {
    label: "Aceptar solicitud",
    icon: "pi pi-check",
    requiresAssignment: true,
  },
  start_preparation: { label: "Iniciar preparación", icon: "pi pi-cog" },
  mark_ready: {
    label: "Completar preparación y crear instalación",
    icon: "pi pi-check-circle",
  },
  approve_quality: { label: "Aprobar para traslado", icon: "pi pi-thumbs-up" },
  reject_quality: {
    label: "Rechazar preparación",
    icon: "pi pi-thumbs-down",
    severity: "danger",
    requiresNote: true,
  },
  confirm_installed: {
    label: "Confirmar instalación",
    icon: "pi pi-power-off",
  },
  request_pickup: { label: "Programar retiro", icon: "pi pi-truck" },
  confirm_returned: {
    label: "Confirmar regreso al taller",
    icon: "pi pi-home",
  },
  close: {
    label: "Cerrar demostración",
    icon: "pi pi-check-square",
    requiresFeedback: true,
  },
  cancel: {
    label: "Cancelar solicitud",
    icon: "pi pi-times",
    severity: "danger",
    requiresNote: true,
  },
};
